
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "6c34865a-651b-48f1-b278-c51b96ceb845"
  },
  "ui": {
    "primary": "green",
    "gray": "cool",
    "colors": [
      "green",
      "red",
      "primary"
    ],
    "strategy": "merge"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/tmp/build/38bfee86/code/app.config.js"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
